<nb-action class="close-dialog" icon="close-outline" (click)="closeAction()"></nb-action>

<nb-card>
  <nb-card-header>{{ context === 'admin' ? 'Retirer un utilisateur' : 'Supprimer un utilisateur' }}</nb-card-header>
  <nb-card-body>
    @if (context === 'admin') {
      <p>
        Êtes-vous sûr de vouloir retirer <strong>{{ user.firstname }} {{ user.lastname }}</strong> de cette exploitation ?
      </p>
    }
    @if (context === 'breederadmin') {
      <p>
        Êtes-vous sûr de vouloir supprimer l'utilisateur <strong>{{ user.firstname }} {{ user.lastname }}</strong> ?
      </p>
    }
    <p class="text-muted">Cette action est irréversible.</p>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton fullWidth status="danger" shape="round" (click)="deleteAction()" [disabled]="loading">
      @if (loading) {
        <nb-spinner size="small"></nb-spinner>
      }
      @if (!loading) {
        <span>{{ context === 'admin' ? 'Retirer' : 'Supprimer' }}</span>
      }
    </button>
  </nb-card-footer>
</nb-card>
